webpackJsonp([59819425949494],{

/***/ 97:
/***/ (function(module, exports, __webpack_require__) {

	var camel2hyphen = __webpack_require__(105);
	
	var isDimension = function (feature) {
	  var re = /[height|width]$/;
	  return re.test(feature);
	};
	
	var obj2mq = function (obj) {
	  var mq = '';
	  var features = Object.keys(obj);
	  features.forEach(function (feature, index) {
	    var value = obj[feature];
	    feature = camel2hyphen(feature);
	    // Add px to dimension features
	    if (isDimension(feature) && typeof value === 'number') {
	      value = value + 'px';
	    }
	    if (value === true) {
	      mq += feature;
	    } else if (value === false) {
	      mq += 'not ' + feature;
	    } else {
	      mq += '(' + feature + ': ' + value + ')';
	    }
	    if (index < features.length-1) {
	      mq += ' and '
	    }
	  });
	  return mq;
	};
	
	var json2mq = function (query) {
	  var mq = '';
	  if (typeof query === 'string') {
	    return query;
	  }
	  // Handling array of media queries
	  if (query instanceof Array) {
	    query.forEach(function (q, index) {
	      mq += obj2mq(q);
	      if (index < query.length-1) {
	        mq += ', '
	      }
	    });
	    return mq;
	  }
	  // Handling single media query
	  return obj2mq(query);
	};
	
	module.exports = json2mq;

/***/ }),

/***/ 100:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}var React=_interopDefault(__webpack_require__(1));__webpack_require__(2);var invariant=_interopDefault(__webpack_require__(8)),json2mq=_interopDefault(__webpack_require__(97));function _defineProperty(e,t,i){return t in e?Object.defineProperty(e,t,{value:i,enumerable:!0,configurable:!0,writable:!0}):e[t]=i,e}function _inheritsLoose(e,t){e.prototype=Object.create(t.prototype),(e.prototype.constructor=e).__proto__=t}function _assertThisInitialized(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}var MediaQueryList=function(){function e(e,t,i){var n=this;this.nativeMediaQueryList=e.matchMedia(t),this.active=!0,this.cancellableListener=function(){n.matches=n.nativeMediaQueryList.matches,n.active&&i.apply(void 0,arguments)},this.nativeMediaQueryList.addListener(this.cancellableListener),this.matches=this.nativeMediaQueryList.matches}return e.prototype.cancel=function(){this.active=!1,this.nativeMediaQueryList.removeListener(this.cancellableListener)},e}(),Media=function(r){function e(){for(var i,e=arguments.length,t=new Array(e),n=0;n<e;n++)t[n]=arguments[n];return _defineProperty(_assertThisInitialized(_assertThisInitialized(i=r.call.apply(r,[this].concat(t))||this)),"state",{matches:i.props.defaultMatches}),_defineProperty(_assertThisInitialized(_assertThisInitialized(i)),"updateMatches",function(){var e=i.mediaQueryList.matches;i.setState({matches:e});var t=i.props.onChange;t&&t(e)}),i}_inheritsLoose(e,r);var t=e.prototype;return t.componentWillMount=function(){if("object"==typeof window){var e=this.props.targetWindow||window;"function"!=typeof e.matchMedia&&invariant(!1);var t=this.props.query;"string"!=typeof t&&(t=json2mq(t)),this.mediaQueryList=new MediaQueryList(e,t,this.updateMatches),this.updateMatches()}},t.componentWillUnmount=function(){this.mediaQueryList.cancel()},t.render=function(){var e=this.props,t=e.children,i=e.render,n=this.state.matches;return i?n?i():null:t?"function"==typeof t?t(n):(!Array.isArray(t)||t.length)&&n?React.Children.only(t):null:null},e}(React.Component);_defineProperty(Media,"defaultProps",{defaultMatches:!0}),module.exports=Media;


/***/ }),

/***/ 101:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(100);
	} else {
	  module.exports = require('./cjs/react-media.js');
	}


/***/ }),

/***/ 105:
/***/ (function(module, exports) {

	var camel2hyphen = function (str) {
	  return str
	          .replace(/[A-Z]/g, function (match) {
	            return '-' + match.toLowerCase();
	          })
	          .toLowerCase();
	};
	
	module.exports = camel2hyphen;

/***/ }),

/***/ 414:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/accor-hotels.75cc49e4.svg";

/***/ }),

/***/ 416:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/campbells.d5045a8a.svg";

/***/ }),

/***/ 417:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/carnival.b72fc02e.svg";

/***/ }),

/***/ 421:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/kraft-heinz.a5c17739.svg";

/***/ }),

/***/ 106:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/nestle-horiz.46e5a28b.svg";

/***/ }),

/***/ 423:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/royal-carib.a93d1363.svg";

/***/ }),

/***/ 426:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 320:
/***/ (function(module, exports) {

	module.exports = {"title1":"Broiler","subtitle1":"Companies across North America, Europe, and other parts of the world are adopting comprehensive animal welfare policies for chickens raised for meat.","buttonText":"track progress","p1":"These companies are eliminating some of the cruelest factory farming practices from their supply chains, changing the way chickens are bred, raised, and slaughtered.","p2":"Chickens raised for meat represent the greatest number of land animals raised and killed for food. Their breeding predisposes them to significant health issues. Their environment is stressful, filthy and devoid of anything related to a natural life. The last hours of their lives are terrifying, involving transport with thousands of other birds to a slaughter facility that typically hangs them upside down, fails to adequately stun them and then slits their throats while they are conscious.","p3":"With roughly 70 billion chickens raised and killed for their meat each year worldwide, these welfare policies play a critical role in reducing immense suffering in factory farms.","titleSpan":[{"titlePartial":"Broiler"},{"titlePartial":"Welfare"},{"titlePartial":"Commitments"}],"subtitle2":"Companies across North America, Europe, and other parts of the world are committing to sweeping welfare reforms for chickens raised for meat. Below are a few examples of many."}

/***/ }),

/***/ 184:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactMedia = __webpack_require__(101);
	
	var _reactMedia2 = _interopRequireDefault(_reactMedia);
	
	var _blocks = __webpack_require__(15);
	
	var _elements = __webpack_require__(7);
	
	var _broiler = __webpack_require__(320);
	
	var _broiler2 = _interopRequireDefault(_broiler);
	
	var _utilities = __webpack_require__(3);
	
	var _Themed = __webpack_require__(23);
	
	var _Themed2 = _interopRequireDefault(_Themed);
	
	var _renderTitleSpan = __webpack_require__(39);
	
	var _kraftHeinz = __webpack_require__(421);
	
	var _kraftHeinz2 = _interopRequireDefault(_kraftHeinz);
	
	var _subwayOld = __webpack_require__(426);
	
	var _subwayOld2 = _interopRequireDefault(_subwayOld);
	
	var _nestleHoriz = __webpack_require__(106);
	
	var _nestleHoriz2 = _interopRequireDefault(_nestleHoriz);
	
	var _campbells = __webpack_require__(416);
	
	var _campbells2 = _interopRequireDefault(_campbells);
	
	var _royalCarib = __webpack_require__(423);
	
	var _royalCarib2 = _interopRequireDefault(_royalCarib);
	
	var _carnival = __webpack_require__(417);
	
	var _carnival2 = _interopRequireDefault(_carnival);
	
	var _accorHotels = __webpack_require__(414);
	
	var _accorHotels2 = _interopRequireDefault(_accorHotels);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Broiler = function (_Component) {
	  _inherits(Broiler, _Component);
	
	  function Broiler() {
	    _classCallCheck(this, Broiler);
	
	    return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	  }
	
	  Broiler.prototype.render = function render() {
	    return _react2.default.createElement(
	      "div",
	      null,
	      this.renderMain(),
	      this.renderCommitments()
	    );
	  };
	
	  //
	  // Partials
	  //
	
	
	  Broiler.prototype.renderMain = function renderMain() {
	    return _react2.default.createElement(
	      _blocks.StyledSection,
	      { background: (0, _utilities.fromThemeProps)("offWhite") },
	      _react2.default.createElement(
	        _blocks.StyledRow,
	        { paddingTop: (0, _utilities.fromThemeProps)("headerHeight") },
	        _react2.default.createElement(
	          _blocks.StyledColumn,
	          { background: "none", paddingTop: "1.5em" },
	          _react2.default.createElement(
	            _Themed2.default,
	            { alt: true },
	            _react2.default.createElement(
	              _elements.H1,
	              null,
	              _react2.default.createElement(
	                "span",
	                null,
	                _broiler2.default.title1
	              )
	            )
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            _elements.H3,
	            null,
	            _broiler2.default.subtitle1
	          ),
	          _react2.default.createElement(
	            _elements.PrimaryButton,
	            { to: "/progress-tracker?filterK=Broiler" },
	            _broiler2.default.buttonText
	          ),
	          _react2.default.createElement(
	            _elements.P,
	            null,
	            _broiler2.default.p1
	          ),
	          _react2.default.createElement(
	            _elements.P,
	            null,
	            _broiler2.default.p2
	          ),
	          _react2.default.createElement(
	            _elements.P,
	            null,
	            _broiler2.default.p3
	          )
	        )
	      )
	    );
	  };
	
	  Broiler.prototype.renderCommitments = function renderCommitments() {
	    return _react2.default.createElement(
	      _blocks.StyledSection,
	      null,
	      _react2.default.createElement(
	        _blocks.StyledRow,
	        null,
	        _react2.default.createElement(
	          _blocks.StyledColumn,
	          null,
	          _react2.default.createElement(
	            _reactMedia2.default,
	            { query: "(max-width: 576px)" },
	            function (matches) {
	              return matches ? _react2.default.createElement(
	                "div",
	                null,
	                (0, _renderTitleSpan.renderTitleSpan)(_broiler2.default, 'alt')
	              ) : _react2.default.createElement(
	                _Themed2.default,
	                { alt: true },
	                _react2.default.createElement(
	                  _elements.H1,
	                  null,
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    _broiler2.default.titleSpan[0].titlePartial,
	                    " ",
	                    _broiler2.default.titleSpan[1].titlePartial
	                  ),
	                  " ",
	                  _react2.default.createElement(
	                    "span",
	                    null,
	                    _broiler2.default.titleSpan[2].titlePartial
	                  )
	                )
	              );
	            }
	          ),
	          _react2.default.createElement("br", null),
	          _react2.default.createElement(
	            _elements.H3,
	            null,
	            _broiler2.default.subtitle2
	          ),
	          _react2.default.createElement(
	            _blocks.StyledLogoList,
	            null,
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _kraftHeinz2.default })
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _subwayOld2.default })
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _campbells2.default })
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _royalCarib2.default })
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _carnival2.default })
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _accorHotels2.default })
	            ),
	            _react2.default.createElement(
	              "li",
	              null,
	              _react2.default.createElement(_elements.CommitmentLogo, { src: _nestleHoriz2.default })
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Broiler;
	}(_react.Component);
	
	exports.default = Broiler;
	module.exports = exports["default"];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-broiler-js-b066384419057db1c370.js